export const historyChapters = [
  {
    title: "Une idée née sur la pente",
    text: "À la fin des années 1970, quelques passionnés de montagne et de parachutisme se demandent s'il est possible de décoller à pied, depuis une pente, sous une voile de parachute. Pas d'avion, pas de largage : seulement le relief et le vent.",
  },
  {
    title: "Le 25 juin 1978",
    text: "Depuis le décollage du Pertuiset, au-dessus de Mieussy, Jean-Claude Bétemps et André Bohn s'élancent. La voile se gonfle, les pieds quittent le sol : le « parachute de pente » est né. Ce vol fait de Mieussy le berceau mondial du parapente.",
  },
  {
    title: "Du village au monde entier",
    text: "Le bouche-à-oreille fait le reste. Les voiles s'allongent, les techniques s'affinent, les écoles se multiplient. En quelques décennies, le parapente devient un sport pratiqué sur tous les continents.",
  },
  {
    title: "2028 : transmettre",
    text: "Cinquante ans plus tard, l'association Mieussy 2028 réunit pilotes, habitants et passionnés pour célébrer cet héritage et le transmettre aux nouvelles générations.",
  },
];

export const pioneers = [
  {
    name: "Jean-Claude Bétemps",
    text: "Pionnier du vol depuis la pente, il fait partie de ceux qui ont cru qu'une voile de parachute pouvait décoller à pied.",
  },
  {
    name: "André Bohn",
    text: "Compagnon de l'aventure du 25 juin 1978, il s'élance lui aussi depuis le Pertuiset ce jour-là.",
  },
];

export const programmeSchedule = [
  {
    day: "Vendredi",
    date: "23 juin",
    title: "Ouverture & mémoire",
    slots: [
      { time: "14:00", title: "Ouverture du village du vol libre", place: "Place du village" },
      { time: "16:00", title: "Vernissage de l'exposition « 1978, l'envol »", place: "Salle des fêtes" },
      { time: "18:30", title: "Accueil officiel des pilotes", place: "Place du village" },
      { time: "21:00", title: "Projection de films d'archives en plein air", place: "Terrain d'atterrissage" },
    ],
  },
  {
    day: "Samedi",
    date: "24 juin",
    title: "Le grand rassemblement",
    slots: [
      { time: "09:00", title: "Briefing pilotes & montée au Pertuiset", place: "Décollage du Pertuiset" },
      { time: "10:30", title: "Décollages en masse", place: "Décollage du Pertuiset" },
      { time: "14:00", title: "Démonstrations de voltige", place: "Terrain d'atterrissage" },
      { time: "16:00", title: "Baptêmes biplace (sur réservation)", place: "Décollage du Pertuiset" },
      { time: "20:30", title: "Concert & soirée festive", place: "Chapiteau" },
    ],
  },
  {
    day: "Dimanche",
    date: "25 juin",
    title: "Le jour anniversaire",
    slots: [
      { time: "10:00", title: "Cérémonie d'hommage aux pionniers", place: "Décollage du Pertuiset" },
      { time: "11:00", title: "Vol commémoratif", place: "Ciel de Mieussy" },
      { time: "12:30", title: "Grand repas partagé", place: "Place du village" },
      { time: "15:00", title: "Clôture du cinquantenaire", place: "Chapiteau" },
    ],
  },
];

export const practicalInfo = [
  {
    title: "Venir à Mieussy",
    text: "Mieussy se trouve en Haute-Savoie, dans la vallée du Giffre. Covoiturage encouragé, parkings fléchés à l'entrée du village.",
  },
  {
    title: "Navettes",
    text: "Des navettes relieront les parkings, le village et le décollage du Pertuiset pendant tout le week-end.",
  },
  {
    title: "Hébergement",
    text: "Gîtes, chambres d'hôtes et campings des environs : réservez tôt, la demande sera forte en juin 2028.",
  },
  {
    title: "Pilotes",
    text: "Les vols seront encadrés. Une inscription préalable sera demandée pour participer aux décollages en masse.",
  },
];

export const faq = [
  {
    q: "L'événement est-il gratuit ?",
    a: "L'accès au village, aux expositions et aux démonstrations est gratuit. Les baptêmes biplace et le repas seront payants.",
  },
  {
    q: "Que se passe-t-il en cas de mauvaise météo ?",
    a: "Les vols dépendent des conditions. Le programme au sol est maintenu et les vols sont décalés si possible.",
  },
  {
    q: "Puis-je voler si je ne suis pas pilote ?",
    a: "Oui, en baptême biplace avec un moniteur diplômé, sur réservation pendant le week-end.",
  },
  {
    q: "Quand ouvrent les inscriptions pilotes ?",
    a: "Les inscriptions seront annoncées dans la newsletter. Inscrivez-vous en bas de page pour être prévenu·e.",
  },
];

export const missions = [
  { id: "accueil", title: "Accueil & information", text: "Orienter le public, tenir les points d'information." },
  { id: "navettes", title: "Navettes", text: "Conduire ou coordonner les rotations vers le décollage." },
  { id: "decollage", title: "Décollage", text: "Assister les pilotes et l'équipe sécurité au Pertuiset." },
  { id: "restauration", title: "Restauration", text: "Buvette, repas partagé, logistique cuisine." },
  { id: "montage", title: "Montage & démontage", text: "Installer le village avant l'événement." },
];

export const membership = [
  { name: "Individuel", price: "20 €", text: "Pour soutenir le projet et participer à l'assemblée générale.", perks: ["Carte d'adhérent", "Newsletter des coulisses", "Droit de vote en AG"] },
  { name: "Famille", price: "35 €", text: "Une adhésion pour tout le foyer, parents et enfants.", perks: ["Tous les avantages Individuel", "Jusqu'à 5 personnes", "Accès prioritaire aux animations"] },
  { name: "Bienfaiteur", price: "100 € +", text: "Pour celles et ceux qui veulent aller plus loin.", perks: ["Tous les avantages Famille", "Nom au livre d'or du cinquantenaire", "Invitation à la soirée des pionniers"] },
];

export const partnerTiers = ["Soutien", "Officiel", "Fondateur"];

export const partnerPerks = [
  { label: "Logo sur le site et les supports", tiers: [true, true, true] },
  { label: "Mention dans la newsletter", tiers: [true, true, true] },
  { label: "Stand au village du vol libre", tiers: [false, true, true] },
  { label: "Invitations à la soirée des pionniers", tiers: [false, true, true] },
  { label: "Logo sur les voiles du vol commémoratif", tiers: [false, false, true] },
  { label: "Prise de parole lors de la cérémonie", tiers: [false, false, true] },
];

export const currentPartners = [
  { name: "Département de la Haute-Savoie", role: "Partenaire institutionnel" },
  { name: "Commune de Mieussy", role: "Partenaire institutionnel" },
];

export const contactSubjects = ["Information générale", "Presse & médias", "Partenariat", "Bénévolat", "Inscription pilote"];
